import { Session } from '@ais-ui/auth';

export const deleteReportTemplate = async (
  session: Session,
  uuid: string
): Promise<null> => {
  const response = await session.request('deleteDefinition', {
    rdUuid: uuid,
  });

  return response;
};

export const deleteReport = async (
  session: Session,
  uuid: string
): Promise<null> => {
  const response = await session.request('deleteJob', {
    jobUuid: uuid,
  });

  return response;
};

export const abortJob = async (
  session: Session,
  jobUuid: string
): Promise<null> => {
  const response = await session.request('abortJob', {
    jobUuid: jobUuid,
  });

  return response;
};
